import { useEffect } from 'react';
import { usePrevious } from './use-previous';

/**
 * A hook to see if a value has actually changed.
 * This is useful when you want to conditionally run a side effect inside
 * of a useEffect that has lots of dependencies.
 * https://stackoverflow.com/questions/55724642/react-useeffect-hook-when-only-one-of-the-effects-deps-changes-but-not-the-oth
 */
const useHasValueChanged = (val: unknown) => {
    const prevVal = usePrevious(val);
    return prevVal !== val;
};

export const useStableEffect = (cb: () => void, val: unknown) => {
    const hasValueChanged = useHasValueChanged(val);

    // Run the effect on every render, but only run the callback
    // if the thing we are watching has actually changed
    useEffect(() => {
        if (hasValueChanged) {
            cb();
        }
    });
};
